import customizeScrollbar from "customsb";
import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { vhostV1 } from "../funcoes";
import Navbar from "../navbar/navbar";
import FooterBar from "../footer/footerBar";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link, Navigate } from "react-router-dom";
import './fichaTecnica.css'; 
import SRI_pagination from "../components/pagination/pagination";
import BuscaVazaia from "../components/buscavazia/buscaVazia";
import RelatorioFichaTecnica from "../reports/fichaTecnica/listaFichaRelatorio";



function FichaTecnica(){
     const [nPag, setnPag] = useState(1);
     const [totalPaginas, setTotalPaginas] = useState(0);
     const [texto,setTexto] = useState('');
     const [busca,setBusca] = useState("");
     const [sResult,setSresult] = useState(0);
     const [tpBusca,setTpBusca] = useState(0);
     const [erroValidacao, setErrovalidacao] = useState(false);
     const [navegar, setNavegar] = useState(false);
     const [msgErro, setmsgErro] = useState('');
     const [fichas, setFichas] = useState([]);
     const [confirmacaoExclusao,setConfirmacaoExclusao] = useState(false);
     const [confirmacaoId,setConfirmacaoID] = useState('');

     let config = {
        headers: {
          'Authorization': localStorage.getItem("token")
        }
      }

    function handlePageChange(value){
        if(value === "&laquo;" || value === '... '){
          setnPag(1);
        }else if (value === "&lsaquo;" ){
          if (nPag !== 1){
            setnPag(-1);
          }
        }else if(value === "&rsaquo;"){
          setnPag(+1);        
        }else if(value === "&raquo;" || value === ' ...' ){
          setnPag(totalPaginas);        
        }else{
          setnPag(value);
        }    
       
       }

       useEffect(function(){
        const sJson = {}  
        sJson.busca = busca;
        sJson.pagina = nPag;
        sJson.regPag = 10;
        
        api.post(vhostV1('webcash/produto/fichas'),sJson,config)
        .then(function (response) {
          setSresult(response.data.result);
          setFichas(response.data.dados);
          setTotalPaginas(response.data.quantidadeDePaginas);
          console.log(response);
          
        }
       ).catch(function (error) {
        console.log(error);
        
       });
       },[busca])


       function apagaFicha(cod){
        
        api.post(vhostV1('webcash/produto/ficha/deletar/'+Number(cod)),{},config)
        .then(function (response) {
          
          console.log(response);
          setConfirmacaoExclusao(false)
          setNavegar(true);
        }
       ).catch(function (error) {
        console.log(error);
        setConfirmacaoExclusao(false)
        
       });
       }

       function confirmadeleteUser(cod){
        setConfirmacaoID(cod);
        setConfirmacaoExclusao(true);
        
     }
  
     
  useEffect(() => {
    // O uso do useEffect garante que a função seja chamada apenas no lado do cliente
    customizeScrollbar({
      scrollbarWidth: "10px",
      trackBackground: "#333",
      thumbBackground:
        "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
      thumbBorderRadius: "10px",
    });
  }, []);



      return <div>
      <Navbar/>
      <div className="container-fluid titulo offset-lg-1 col-lg-10">
      <h1>Ficha técnica de Produtos</h1>
      <hr />

      <div className="row">
      <div className="col-2">
            
            <select class="form-select" onChange={(e)=> setTpBusca(e.target.value)} aria-label="Default select example">
              <option value={0} selected>Qualquer parte</option>
              <option value={1}>Começando com...</option>
              <option value={2}>Finalizando com...</option>
            </select>
          </div>

        <div className="col-7">
          <div className="input-group mb-3">
            <input onChange={(e) => setTexto(e.target.value)} type="text" className="form-control" placeholder="Digite sua pesquisa" aria-describedby="button-addon2" />
            <button onClick={(e) => setBusca(texto)} className="btn btn-primary" type="button" id="button-addon2">Pesquisar</button>
          </div>
        </div>

        <div className="col-3">
           <Link id='botao-produto' to='/app/novaFichaTecnica/0/-1' className="btn btn-primary btn-cli" type="button"><i className="bi bi-plus-circle-fill"></i> Ficha Técnica</Link>
           <button 
    id='botao-produto' 
    className="btn btn-danger btn-cli" 
    type="button"
    onClick={() => RelatorioFichaTecnica(fichas)}
    >
    <i className="bi bi-printer-fill"></i> Relatório
  </button>
        </div>
        
          
        
      </div>   

       <table id='table-grupos' className="table table-hover table-striped">
          <thead>
          <tr>
              <th scope='col'>Código</th>
              <th scope="col">Descricao</th>
              <th scope="col">Ações</th>
              </tr>
          </thead>
          <tbody className="table-group-divider">
            { fichas ? 
               fichas.map((produto)=> {
                return <tr key={produto.COD_PRODUTO}>
                    <td>{produto.COD_PRODUTO}</td>
                    <td>{produto.DESCRICAO}</td>
                    <td>
                    <button id='table-prod' className="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                          Ações
                   </button>
                       <ul className="dropdown-menu">
                          {/* <li>
                             <Link to={`/app/novaFichaTecnica/${produto.ID}/-1`} className="dropdown-item">
                             <i className="bi bi-plus-circle-fill"></i> Adicionar
                             </Link>
                          </li> */}
                          <li>
                              <Link to={`/app/novaFichaTecnica/${produto.COD_PRODUTO}/0`} className="dropdown-item">
                              <i className="bi bi-eye-fill"></i> Visualizar
                              </Link>
                         </li>
                          <li>
                               <Link to={`/app/novaFichaTecnica/${produto.COD_PRODUTO}/2`} className="dropdown-item">
                               <i className="bi bi-pen-fill"></i> Editar
                               </Link>
                         </li>
                         <li>
                                <button onClick={() => confirmadeleteUser(produto.COD_PRODUTO)} className="dropdown-item">
                                <i className="bi bi-trash-fill"></i> Excluir
                                </button>
                         </li>
                        

                        </ul>
                    </td>
                </tr>
            } ): BuscaVazaia}  
          </tbody>
        </table>

        <div className="row mt-5 mb-5">
            <SRI_pagination totalPage={totalPaginas} 
                            page={nPag} 
                            limit={10} 
                            siblings={1}
                            onPageChange={handlePageChange}/>
            </div>

        {
         erroValidacao ? 
         <SweetAlert
            danger
            confirmBtnText="OK"
            confirmBtnBsStyle="danger"
            title="Erro"
            onConfirm={() => setErrovalidacao(false)}                            
          >
            {msgErro}
          </SweetAlert>:null
         
        }

        {
                   confirmacaoExclusao ? 
                   <SweetAlert
                      warning
                      showCancel
                      showCloseButton
                      confirmBtnText="Sim"
                      confirmBtnBsStyle="danger"
                      cancelBtnText="Não"
                      cancelBtnBsStyle='ligth'
                      title="Atenção"
                      onConfirm={() =>apagaFicha(confirmacaoId)}
                      onCancel={() => setConfirmacaoExclusao(false)}
                      focusCancelBtn
                      reverseButtons
                    >
                      Deseja excluir esta Ficha?
                    </SweetAlert>:null
                   
                  }

       

        {navegar ? <Navigate to='/app/fichaTecnica' /> && window.location.reload()  : null}
   
    </div>  
    <FooterBar/>   
  </div>
  
};

export default FichaTecnica;